import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom"; // Import withRouter
import ConfirmApprovedModel from "./ConfirmApprovedModel";
import ConfirmRejectModel from "./ConfirmRejectModel";
const token = localStorage.getItem('authToken');
class EditClassified extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: "",
      userName: "",
      title: "",
      category: '', // Initialize as empty
      categoryId: null, // Track the original category ID
      categoryChanged: false, // Track if category has been changed
      areaInput: "",
      categoryData: [],
      currentImageUrls: [],
            existingImages: [],
      submissionStatus: null,
      currentImageUrl: null,
      submissionStatus: null,
      submeet: false,
      errors: [],
      price: "",
      pincode: "",
      address: "",
      showModal: false,
      selectedCategoryId: null,
      showModalReject: false,
      selectedCategoryIdReject: null,
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
    };
  }
  

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this?.userData(id);
    } else {
      console.error("No match params found.");
    }
    this.fetchData();
  }

  userData = async (id) => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/classified/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      if (response) {
        console.log(response.data);
     
        this.setState({
          title: response.data.title,
          category: response?.data?.category?.name,
          categoryId: response?.data?.category?.id, // Store the original category ID
          areaInput: response.data.description,
          price: response?.data?.price,
          pincode: response?.data?.pincode,
          address: response?.data?.address,
     
          existingImages: response.data.images,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  fetchData = async () => {
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/classifiedcategory`,{
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
      if (response.data) {
        this.setState({ categoryData: response?.data?.categories });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };


  handleApprove = (id) => {
    this.setState({ selectedCategoryId: id, showModal: true });
  };
  handleReject= (id) => {
    this.setState({ selectedCategoryIdReject: id, showModalReject: true });
  };

  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    const selectedImages = files.filter((file) => {
        const isValidSize = file.size <= this.state.maxSize;
        if (!isValidSize) {
            errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
        }
        return isValidSize;
    });

    this.setState({
        textInput: selectedImages,
        currentImageUrls: selectedImages.map((file) => URL.createObjectURL(file)),
        errors,
    });
};
  handleUpdate = async (e) => {
    const { id } = this.props.match.params;

    try {
    
      const formData = new FormData();
      formData.append('status', 'approved');

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/classified/${id}`, formData,{
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
     console.log(response.data)
      if (response.status === 200) {
        this.setState({ showModal: false })}
    
      
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  handleUpdateReject= async (e) => {
    const { id } = this.props.match.params;

    try {
    
      const formData = new FormData();
      formData.append('status', 'no');

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/classified/${id}`, formData,{
        headers: {
          Authorization: `Bearer ${token}`, 
        },
      });
     console.log(response.data)
      if (response.status === 200) {
        this.setState({ showModalReject: false })}
    
      
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };


  handleCategoryChange = (e) => {
    const selectedCategoryId = e.target.value;
    console.log("Selected Category ID:", selectedCategoryId);
    console.log("Current categoryData:", this.state.categoryData);

    const selectedCategory = this.state.categoryData.find(category => category.id.toString() === selectedCategoryId);

    if (selectedCategory) {
        this.setState({
            category: selectedCategory.name,
            categoryId: selectedCategory.id,
            categoryChanged: true,
        });
    } else {
        console.error(`Category with ID ${selectedCategoryId} not found`);
    }
};

  handleSubmit = async (e) => {
    e.preventDefault();

    this.setState({ submeet: true });

    const { textInput, title, areaInput, category, categoryId, categoryChanged,existingImages, price,pincode,address } = this.state;
    const { id } = this.props.match.params;

    try {
      const formData = new FormData();
   
      if (textInput.length > 0) {
          textInput.forEach((file) => {
              formData.append('images', file);
          });
      } else {
          existingImages.forEach((url) => {
              formData.append('existingImages', url);
          });
      }
      formData.append('title', title);
      formData.append('description', areaInput);
      formData.append('category', categoryId);

      formData.append('pincode', pincode);
      formData.append('price', price);
      formData.append('address', address);


      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
         
            Authorization: `Bearer ${token}`, 
      
        },
      };
     

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/classified/${id}`, formData, config);

      if (response.status === 200) {
        this.setState({ submissionStatus: 'success', submeet: false });
        setTimeout(() => {
          this.props.history.push ("/classifiedlist");
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      this.setState({ submissionStatus: 'error' });
    }
  };

  render() {
    const { textInput, showModal, selectedCategoryId,selectedCategoryIdReject, existingImages,errors,showModalReject,isDateValid,date,title,currentImageUrls,price,pincode,address, userName,category,categoryData, submeet,areaInput, submissionStatus } = this.state;
    const isNameValid = userName?.trim().length > 0;
    const isTitleValid = title?.trim().length > 0;
   
    const isaddressValid = address?.trim().length >0;
    const ispincodeValid = pincode?.trim().length >0;
    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Classified</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
            <div className="form-group">
                <label>Title</label>
                <input
                  className={`form-control ${!isTitleValid && submeet && "parsley-error"}`}
                  value={title}
                  name="title"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ title: e.target.value });
                  }}
                />
                {!isTitleValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
               

              <div className="form-group">
                                <label htmlFor="bloodGroup">Category</label>
                                <select
                                    className={`form-control ${submeet && !this.state.categoryId && "parsley-error"}`}
                                    value={this.state.categoryId || ''}
                                    name="category"
                                    required=""
                                    onChange={this.handleCategoryChange}
                                >
                                    <option value="" disabled>Select a category</option>
                                    {categoryData && categoryData.map((key) => (
                                        <option key={key.id} value={key.id}>{key.name}</option>
                                    ))}
                                </select>
                                {submeet && !this.state.categoryId ? (
                                    <ul className="parsley-errors-list filled" id="parsley-id-29">
                                        <li className="parsley-required">Category is required.</li>
                                    </ul>
                                ) : null}
                            </div>
                            <div className="form-group">
  <label>Images</label>

  {/* Render new images or existing images correctly */}
  {(textInput.length > 0 ? currentImageUrls : existingImages).map((imageUrl, index) => (
    <div key={index}>
      <img 
        src={textInput.length > 0 ? imageUrl : `https://uma-classees.blr1.digitaloceanspaces.com/${imageUrl}`} 
        alt={`Image ${index}`} 
        style={{ width: '100px', marginBottom: '10px' }} 
      />
    </div>
  ))}

  <input
    type="file"
    className={`form-control ${!textInput.length && submeet && "parsley-error"}`}
    name="textInput"
    multiple
    onChange={this.handleChange}
  />
  {!textInput.length && submeet ? (
    <ul className="parsley-errors-list filled">
      <li className="parsley-required">This value is required.</li>
    </ul>
  ) : null}

  {errors.length > 0 && (
    <ul className="parsley-errors-list filled">
      {errors.map((error, index) => (
        <li key={index} className="parsley-required">{error}</li>
      ))}
    </ul>
  )}
</div>


              <div className="form-group">
                <label>Pincode</label>
                <input
                  className={`form-control ${submeet}`}
                  value={pincode}
                  name="pincode"
                  required=""
                  type="number"
                  onChange={(e) => {
                    this.setState({ pincode: e.target.value });
                  }}
                />
                {/* {!ispriceValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null} */}
              </div>
            
              <div className="form-group">
                <label>Address</label>
                <input
                  className={`form-control ${!isaddressValid && submeet && "parsley-error"}`}
                  value={address}
                  name="address"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ address: e.target.value });
                  }}
                />
                {!isaddressValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
                <label>Price</label>
                <input
                  className={`form-control ${submeet }`}
                  value={price}
                  name="price"
                  required=""
                  type="number"
                  onChange={(e) => {
                    this.setState({ price: e.target.value });
                  }}
                />
                {/* {!ispriceValid && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null} */}
              </div>
                 <div className="form-group">
                <label>Description</label>
                <textarea
                  className={`form-control ${areaInput === "" && submeet && "parsley-error"
                    }`}
                  value={areaInput}
                  cols="30"
                  name="textarea"
                  required=""
                  rows="5"
                  onChange={(e) => {
                    this.setState({ areaInput: e.target.value });
                  }}
                ></textarea>
                {areaInput === "" && submeet ? (
                  <ul className="parsley-errors-list filled" id="parsley-id-29">
                    <li className="parsley-required">
                      This value is required.
                    </li>
                  </ul>
                ) : null}
              </div>
              <div className="form-group">
          <label>Actions</label><br></br>
          <div className="btn-group">
            <button type="button" className="btn btn-success" 
           onClick={() => this.handleApprove(category.id)}
            >
              Approve
            </button>&nbsp; &nbsp;&nbsp;
            <button type="button" className="btn btn-danger" onClick={() => this.handleReject(category.id)}>
              Reject
            </button>
          </div>
        </div>

              {submissionStatus === 'success' && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
        <ConfirmApprovedModel
          show={showModal}
          handleClose={() => this.setState({ showModal: false })}
          handleConfirm={() => this.handleUpdate(selectedCategoryId)}
        />
         <ConfirmRejectModel
          show={showModalReject}
          handleClose={() => this.setState({ showModalReject: false })}
          handleConfirm={() => this.handleUpdateReject(selectedCategoryId)}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditClassified)); // Wrap with withRouter
